export default class MultiFilterItem {
  public value: string;
  constructor(value: string = '') {
    this.value = value;
  }
}